export class FindAppointment {
  specialty: string;
  provider: string;
  date = 0;
  show = '0';
}
